import React, { useState } from "react";
import { Link } from "gatsby";
import Seo from "../components/seo";
import Layout from "../components/layout/layout";
import { Container, Row, Col, Image, Tab, Nav, Card, Modal, Button } from "react-bootstrap";
import { HomeMeta } from "../data/metaData";
import { StaticImage } from "gatsby-plugin-image";
import LazyLoad from 'react-lazy-load'

// import { Animations } from "../components/animations";
// import YelowsoftBannerImg from "../animations/home/home_page.json";

// import yelowetaxiSMlogo from '../images/yelowtaxi-sm-logo.svg';
// import yelowexpressSMlogo from '../images/yelowexpress-sm-logo.svg';
// import yelowmileSMlogo from '../images/yelowmile-sm-logo.svg';
// import yelowetaxi from '../images/yelowtaxi-sm-logo.svg';
// import yelowexpress from '../images/yelowexpress-logo.svg';
// import yelowmile from '../images/yelowmile-logo.svg'

import Airport from '../images/icon/airport-menu.svg';
import Corporate from '../images/icon/corporate-transfer-menu.svg';
import RaidHailing from '../images/icon/ride-hailing-menu.svg';
import TaxiDispatch from '../images/icon/dispatch-menu.svg';
import Limo from '../images/icon/suv.svg';

import HomeTabIcon1 from '../images/icon/home-tab-computer-interface.svg'
import HomeTabIcon2 from '../images/icon/home-tab-security.svg'
import HomeTabIcon3 from '../images/icon/home-tab-support.svg'
import HomeTabIcon4 from '../images/icon/home-tab-setting.svg'
import HomeTabIcon5 from '../images/icon/home-tab-data.svg'
import HomeTabIcon6 from '../images/icon/home-tab-payment.svg'

import Icon1 from '../images/icon/index-integration.svg';
import Icon2 from '../images/icon/index-automation.svg';
import Icon3 from '../images/icon/index-payment.svg';
import Icon4 from '../images/icon/index-responsive.svg';

// For Slider
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';


const MultipleProjectDelivered = React.lazy(() => import("../components/multiple-project-delivered"))
const Client = React.lazy(() => import("../components/client"))
const Facts = React.lazy(() => import("../components/facts"))
const FooterCta = React.lazy(() => import("../components/footer-cta"))
// const Solutionyelowtaxi = React.lazy(() => import("../components/solution-yelowtaxi"))
const Featureyelowtaxi = React.lazy(() => import("../components/feature-yelowtaxi"))
const Faqs = React.lazy(() => import("../components/faq"))

const schemaOrgJSONLD1 =
{
  "@context": "https://schema.org/",
  "@type": "Product",
  "name": "On-Demand Taxi Dispatch & Delivery Software",
  "image": "https://www.yelowsoft.com/logo.svg",
  "description": "A bespoke, ready to use white label taxi dispatch software solution to simplify your business management. Automate your taxi & limo operations and boost profit rapidly.",
  "brand": {
    "@type": "Brand",
    "name": "yelowsoft"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "150"
  }
}

const schemaOrgJSONLD2 =
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What is Yelowsoft?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yelowsoft is an all-in-one platform that automates taxi operations. It includes a web booking engine, passenger app, driver app, and dispatch software, simplifying booking, management, and dispatch processes."
    }
  }, {
    "@type": "Question",
    "name": "Is Yelowsoft suitable for small taxi companies?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, Yelowsoft is adaptable for taxi companies of all sizes, offering features tailored to small, medium, and large operations."
    }
  }, {
    "@type": "Question",
    "name": "I already have a dispatch system. Why should I switch to Yelowsoft?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Switching to Yelowsoft can save you up to 50% on monthly costs, offering more value and enhanced functionality compared to other systems."
    }
  }, {
    "@type": "Question",
    "name": "Can I use Yelowsoft for different types of transport companies?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, our airport taxi booking platform provides automated booking management and reservation tools to simplify the booking process for customers and companies. Customers can book online or through the mobile app, while admin can easily manage all bookings."
    }
  }, {
    "@type": "Question",
    "name": "How can I get started with Yelowsoft?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Getting started with Yelowsoft is simple. Contact our sales team for a demo or sign up for a free trial here."
    }
  },

  ]
}

const schemaOrgJSONLD3 =
{
  "@context": "https://schema.org",
  "@type": "Corporation",
  "name": "Yelowsoft",
  "alternateName": "Yelowsoft",
  "url": "https://www.yelowsoft.com/",
  "logo": "https://www.yelowsoft.com/logo.svg",
  "sameAs": [
    "https://www.facebook.com/yelowsoft/",
    "https://x.com/yelowsoft",
    "https://www.instagram.com/yelowsoft/",
    "https://www.youtube.com/channel/UCKrrVHIZ1EefGKiZ_DPa_8A",
    "https://www.linkedin.com/company/13587119/admin/dashboard/",
    "https://in.pinterest.com/yelowsoft",
    "https://www.yelowsoft.com/"
  ]
}

export const Head = () => (
  <> <Seo
    title={HomeMeta.metaTitle}
    description={HomeMeta.metaDescription}
    keywords={HomeMeta.keywords}
    ogTitle={HomeMeta.ogTitle}
    ogDescription={HomeMeta.ogDescription}
    ogType={HomeMeta.ogType}
    ogSiteName={HomeMeta.ogSiteName}
    ogImage={HomeMeta.ogImage}
    twitterCard={HomeMeta.twitterCard}
    twitterCreator={HomeMeta.twitterCreator}
    twitterTitle={HomeMeta.twitterTitle}
    twitterDescription={HomeMeta.twitterDescription}
    twitterImage={HomeMeta.twitterImage}
  />
    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD1)}
    </script>

    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD2)}
    </script>

    <script type="application/ld+json">
      {JSON.stringify(schemaOrgJSONLD3)}
    </script>

  </>
)

const IndexPage = () => {

  const YelowsoftFeatureOnIcon = '../images/yelowsoft-feature-on-icon.png';
  const Banner = '../images/taxi-home-banner.png';
  const CtaImage1 = '../images/homepage-cta-img-1.png';
  const CtaImage2 = '../images/homepage-cta-img-2.png';
  const BgGradiantLine = '../images/bg-gradiant-line-pattern.webp';
  const HomeTabImage1 = '../images/homepage-tab-image-easytouse.png';
  const HomeTabImage2 = '../images/homepage-tab-image-security.png';
  const HomeTabImage3 = '../images/homepage-tab-image-support.png';
  const HomeTabImage4 = '../images/homepage-tab-image-white-label.png';
  const HomeTabImage5 = '../images/homepage-tab-image-data-migration.png';
  const HomeTabImage6 = '../images/homepage-tab-image-software-pricing.png';

  const SoftwareAdvice = '../images/software-advice.png';
  const Capterra = '../images/capterra.png';
  const ProductHunt = '../images/product-hunt.png';

  const swiperdata = [


    {
      id: 4,
      title: "<span class='text-primary'>Taxi dispatch </span> platform",
      description: 'Yelowsoft provides the best taxi dispatch platform to transform taxi dispatch business operations. ',
      list: [
        { list1: "Streamline operations " },
        { list1: "Automate bookings " },
        { list1: "Easily manage multiple orders " },
        { list1: "Boost profits" },
      ],
      hovertitle: "Powering taxi dispatchers use Yelowsoft to stand out from the competition. The solution is a comprehensive suite of;",
      hoverlist: [
        {
          hoverlist1: "Dispatch panel ",
          hoverlistlink1: "/dispatcher",
        },
        {
          hoverlist1: "Driver app ",
          hoverlistlink1: "/driver-app",
        },
        {
          hoverlist1: "Reports and analytics",
          hoverlistlink1: "/admin/reporting-and-analytics/",
        },
        {
          hoverlist1: "And more…",
          hoverlistlink1: "/features",
        },
      ],
      explore: "Know More",
      explorelink: "/taxi-dispatch-platform",
      img: TaxiDispatch,
      hoverimg: TaxiDispatch
    },
    {
      id: 2,
      title: "<span class='text-primary'>Airport transfer </span> software",
      description: "Yelowsoft's airport transfer booking software automates the booking and scheduling process and gives real-time flight status.",
      list: [
        { list1: "Drive growth" },
        { list1: "Grow revenue" },
        { list1: "Boost efficiency" },
        { list1: "Increase bookings" }
      ],
      hovertitle: "Yelowsoft offers the #1 airport taxi booking software to help you operate taxis and trips smartly. The software comes with: ",
      hoverlist: [
        {
          hoverlist1: "Web booking ",
          hoverlistlink1: "/web-based-taxi-booking-system",
        },
        {
          hoverlist1: "Driver app ",
          hoverlistlink1: "/driver-app",
        },
        {
          hoverlist1: "Zone-based pricing",
          hoverlistlink1: "/admin/zone-management",
        },
        {
          hoverlist1: "Flight updates and more.",
          hoverlistlink1: "/features",
        }
      ],
      explore: "Know More",
      explorelink: "/airport-taxi-transfer-software",
      img: Airport,
      hoverimg: Airport
    },


    {
      id: 1,
      title: "<span class='text-primary'>Ride hailing </span> app",
      description: 'Our intelligent ride-hailing software allows you to manage all ride-hailing operations at your fingertips.',
      list: [
        { list1: "Save time" },
        { list1: "Reduce costs" },
        { list1: "5x your revenue " },
        { list1: "Surpass customers’ expectations " },
      ],
      hovertitle: "With Yelowsoft, you can launch your ride hailing app in just 3 weeks. Modules that our ride hailing software offers are:  ",
      hoverlist: [
        {
          hoverlist1: "Passenger app",
          hoverlistlink1: "/passenger-app",
        },
        {
          hoverlist1: "Admin panel",
          hoverlistlink1: "/admin",
        },
        {
          hoverlist1: "Driver app",
          hoverlistlink1: "/driver-app",
        },
        {
          hoverlist1: "And more…",
          hoverlistlink1: "/features",
        },
      ],
      explore: "Know more",
      explorelink: "/ride-hailing-software",
      img: RaidHailing,
      hoverimg: RaidHailing
    },
    {
      title: "<span class='text-primary'>Limo booking </span> software",
      id: 5,
      description: 'Modern cloud-based limo booking software platform for limousines, black car and livery businesses globally. ',
      list: [
        { list1: "Simplify bookings " },
        { list1: "Automate operations " },
        { list1: "Maximize productivity " },
      ],
      hovertitle: "We empower limo transfer service providers to run and manage their business from anywhere, anytime. With Yelowsoft, limo company will get;",
      hoverlist: [
        {
          hoverlist1: "Dispatch software ",
          hoverlistlink1: "/dispatcher",
        },
        {
          hoverlist1: "Chauffeurs app ",
          hoverlistlink1: "/driver-app",
        },
        {
          hoverlist1: "Web booking",
          hoverlistlink1: "/web-based-taxi-booking-system",
        },
        {
          hoverlist1: "And more…",
          hoverlistlink1: "/features",
        },
      ],
      explore: "Know More ",
      explorelink: "/limo-dispatch-booking-software",
      img: Limo,
      hoverimg: Limo
    },
    {
      id: 3,
      description: 'Streamline booking process, improve efficiency and increase the number of rides with our corporate cab booking software.',
      title: "<span class='text-primary'>Corporate transfer </span> software",
      list: [
        { list1: "Simplify business management " },
        { list1: "Improve transportation service " },
        { list1: "Reduce cost " },
        { list1: "Increase revenue" },
      ],
      hovertitle: "With Yelowsoft, you can manage operations at your fingertips and take control of the entire business. The software is armed with:",
      hoverlist: [

        {
          hoverlist1: "Corporate panel ",
          hoverlistlink1: "/admin/corporate-account-management",
        },
        {
          hoverlist1: "Admin panel ",
          hoverlistlink1: "/admin",
        },
        {
          hoverlist1: "Driver app ",
          hoverlistlink1: "/driver-app",
        },
        {
          hoverlist1: "And more…",
          hoverlistlink1: "/features",
        },
      ],
      // explore: "coming soon",
      explore: "Know More",
      explorelink: "/corporate-taxi-booking-solution",
      img: Corporate,
      hoverimg: Corporate
    },





  ]
  const featuredata = [
    {
      title: "Driver App",
      keyname: "driver",
      tabdetail: [
        {
          title: "Empower your drivers to deliver better rides.",
          slug: "/driver-app",
          explorelink: "Explore Driver App",
          list: [
            { list1: "Instant ride requests" },
            { list1: "Real time GPS tracking" },
            { list1: "Earning dashboard" },
            { list1: "Customer feedback system" },
          ],

        },
      ],
    },
    {
      title: "Admin",
      keyname: "admin",
      tabdetail: [
        {
          title: "Manage your business from anywhere. ",
          slug: "/admin",
          explorelink: "Explore Admin",
          list: [
            { list1: "Live driver tracking" },
            { list1: "Automated dispatching" },
            { list1: "Fleet & earnings analytics" },
            { list1: "Manage pricing & promotions" }
          ],

        }
      ]
    },
    {
      title: "Passenger App",
      keyname: "user",
      tabdetail: [
        {
          title: "Give customers a ride-booking experience they love.",
          slug: "/passenger-app",
          explorelink: "Explore Passenger App",
          list: [
            { list1: "One-tap ride booking" },
            { list1: "Easy payment options" },
            { list1: "Transparent pricing" },
            { list1: "Live ride tracking" }
          ],
        },
      ]
    },
    {
      title: "Web Booking",
      keyname: "web-booking",
      tabdetail: [
        {
          title: "Get more direct bookings from your website. No app needed.",
          slug: "/web-based-taxi-booking-system",
          explorelink: "Explore Web Booking",
          list: [
            { list1: "No app needed" },
            { list1: "Mobile-friendly design " },
            { list1: "Secure online payments " },
            { list1: "Boosts direct bookings" }
          ],
        }
      ]
    },
    {
      title: "Kiosk",
      keyname: "kiosk",
      slug: "/web-kiosk-app-hotels-restaurants-receptions",
      explorelink: "Explore Kiosk",
      tabdetail: [
        {
          title: "Offer hassle-free bookings at Airports, Hotels, & Malls",
          list: [
            { list1: "Tap & book in seconds " },
            { list1: "Perfect for airports, malls, & hotels " },
            { list1: "Branded for your business " },
            { list1: "Instant driver allocation" }
          ],
        }
      ]
    },
    {
      title: "Dispatcher",
      keyname: "dispatcher",
      tabdetail: [
        {
          title: "Take full control of your ride assignments",
          slug: "/dispatcher",
          explorelink: "Explore Dispatcher Panel",
          list: [
            { list1: "Assign rides in real-time " },
            { list1: "Reduce wait times " },
            { list1: "Emergency ride support " },
            { list1: "Live trip monitoring " }
          ],
        }
      ]
    },
  ]

  const slidergo = [
    {
      title: "Payment gateways",
      newlogo: [
        {
          class: "logo-1"
        },
        {
          class: "logo-2"
        },
        // {
        //   class: "logo-3"
        // },
        {
          class: "logo-4"
        },
        {
          class: "logo-5"
        },
        {
          class: "logo-6"
        },
        {
          class: "logo-7"
        },
        {
          class: "logo-8"
        },
        {
          class: "logo-9"
        },
        {
          class: "logo-10"
        },
        {
          class: "logo-11"
        },
        {
          class: "logo-12"
        }
      ]
    },
    {
      title: "Notifications",
      keyname: "notification",
      newlogo: [
        {
          class: "logo-13"
        },
        {
          class: "logo-14"
        },
        {
          class: "logo-15"
        },
        {
          class: "logo-16"
        },
        {
          class: "logo-17"
        },
        {
          class: "logo-18"
        },
        {
          class: "logo-19"
        },
        {
          class: "logo-20"
        },
        {
          class: "logo-21"
        },
        {
          class: "logo-22"
        },
        {
          class: "logo-23"
        },
        {
          class: "logo-24"
        }
      ]
    },
    {
      title: "Email gateways",
      newlogo: [
        {
          class: "logo-25"
        },
        {
          class: "logo-26"
        },
        {
          class: "logo-27"
        },
        {
          class: "logo-28"
        },
        {
          class: "logo-25"
        },
        {
          class: "logo-26"
        },
        {
          class: "logo-27"
        },
        {
          class: "logo-28"
        },
        {
          class: "logo-25"
        },
        {
          class: "logo-26"
        },
        {
          class: "logo-27"
        },
        {
          class: "logo-28"
        },

      ]
    }
  ]

  const RevolutionizingTab = [
    {
      title: "Easy to use interface",
      description: "Our white label taxi management software is a comprehensive suite of passenger & driver apps and dispatcher and admin panel — all are easy to use. ",
      keyname: "easytouse",
      icon: HomeTabIcon1
    },
    {
      title: "Security and compliance",
      description: "Yelowsoft follows industry-leading security protocols and compliance standards to ensure your data, transactions, and business operations are fully protected.",
      keyname: "security",
      icon: HomeTabIcon2
    },
    {
      title: "Quick support",
      description: "We provide rapid support to ensure your operations are never interrupted. Plus, our experts are always available for help when you need it.",
      keyname: "support",
      icon: HomeTabIcon3
    },
    {
      title: "While lable solution",
      description: "Yelowsoft offers a fully customizable white-label taxi dispatch software that lets you launch your app with your logo, name, colors, and branding.",
      keyname: "white-label",
      icon: HomeTabIcon4
    },
    {
      title: "Data migration",
      description: "We ensure a smooth and hassle-free data migration process to yelowsoft from your existing software. Our experts preserve data integrity and minimizing service disruption. ",
      keyname: "data-migration",
      icon: HomeTabIcon5
    },
    {
      title: "Competitive pricing",
      description: "Whether you're a small startup or a large enterprise, our flexible pricing plans ensure you get the best value withuot compromising on quality.",
      keyname: "software-pricing",
      icon: HomeTabIcon6
    }
  ]

  const accordiandata = [
    {
      title: "What makes Yelowsoft different from other taxi software providers?",
      description: "Automation, scalability, and white label taxi dispatch system makes us different from other taxi software providers. Plus, our software is designed to help every taxi business reduce operational costs bupto 50%, increase efficiency, and create a seamless ride experience for both drivers and passengers. All these factors makes us stand apart from other taxi software providers."
    },
    {
      title: "How easy is it to switch from my current software?",
      description: "It is super easy to switch from your current software to Yelowsoft! Our data migration team ensures a smooth transition with zero data loss so you can keep all your ride history, driver details, and customer records intact."
    },
    {
      title: "What integrations does Yelowsoft support?",
      description: "Yelowsoft supports all third-party tool integrations. Be it local or international payment gateways, SMS services, CRM tools, and fleet management APIs—just tell us what you need, and we’ll integrate it!"
    },
    {
      title: "Can I monitor rides and driver activity in real-time?",
      description: "Yes! With Yelowsoft’s real-time tracking dashboard, you can see every ride, every driver, and every booking as it happens."
    },
    {
      title: "Do you offer a free demo?",
      description: "Yes! Book a free demo today and see how Yelowsoft can transform your taxi business."
    }
  ]


  const featuredatanewpoint = [
    {
      feturetext: "Easy to integrate and use",
      img: Icon1,
      width: 54,
      height: 54
    },
    {
      feturetext: "Fully automated",
      img: Icon2,
      width: 54,
      height: 54
    },
    {
      feturetext: "Pay as you go",
      img: Icon3,
      width: 54,
      height: 54
    },
    {
      feturetext: "White-label software",
      img: Icon4,
      width: 54,
      height: 54
    },
  ]
  const [showClickToGo, setClickToGo] = useState(false);

  const handleShowClickToGo = () => setClickToGo(true);
  const handleCloseClickToGo = () => setClickToGo(false);

  return (
    <>
      <Layout>
        <section className="section dark-banner" >
          <Container>
            <Row className="g-5 align-items-center" xs={1} lg={2}>
              <Col className="d-flex flex-column">
                <div className="banner-content">
                  <h1 className="heading mb-3 text-white">
                    Stop losing rides. Start growing with <span className="text-primary">AI-powered taxi management software</span>
                  </h1>
                  <p className="subline mb-4-lg text-grey lead">Yelowsoft helps you build a profitable and modern taxi service provider with real-time tracking, seamless payments, and full automation—so you can compete easily with the competitors and run your own branded business.</p>
                  <div className="d-grid0 gap-2">
                    {/* <Link to="/pricing" className="btn btn-lg btn-primary-theme me-4 mb-3">
                      <span>Get started free</span>
                    </Link> */}
                    <a href="https://service.yelowsoft.co/signup?pricing=3" className="btn btn-lg btn-primary-theme me-4 mb-3" aria-label="Get Started Free" rel="noreferrer" target="_blank">
                      <span>Get started free</span>
                    </a>
                    <a href="/demo" className="btn btn-lg btn-primary-theme-outline mb-3" aria-label="Book a demo" rel="noreferrer" target="_blank">
                      <span>Book a demo</span>
                    </a>
                  </div>
                  <div className="banner-logo mt-5">
                    <p className="fw-bold text-white">Featured On</p>
                    <StaticImage loading="lazy" src={YelowsoftFeatureOnIcon} width={393} height={24} alt="yelowsoft-feature-on-icon" />
                  </div>
                </div>
              </Col>
              <Col className="d-none d-lg-block">
                <div className="video-iframe banner-popup-video" onClick={handleShowClickToGo} onKeyDown={handleShowClickToGo} role="button" tabIndex="0">
                  <div className="icon-play zmdi zmdi-play"></div>
                  <StaticImage layout="fixed" loading="lazy" src={Banner} width={952} height={586} alt="best-taxi-dispatch-platform" />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Modal size="xl" show={showClickToGo} onHide={handleCloseClickToGo} centered>
          <Modal.Body>
            <div className="text-end video-close-btn">
              <Button variant="" className="btn-close" onClick={handleCloseClickToGo}></Button>
            </div>
            <div className="ratio ratio-16x9">
              <iframe className="lazyload" loading="lazy" src="https://www.youtube.com/embed/b9u3OQRZYZw?autoplay=1&loop=1&playlist=b9u3OQRZYZw&rel=0&modestbranding=1&showinfo=0&iv_load_policy=3" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            </div>
          </Modal.Body>
        </Modal>
        {/* <section className="section banner-section home-banner pb-0">
          <Container className="py-5">
            <Row className="g-4 align-items-center">
              <Col lg={6} className="d-flex flex-column">
                <div className="banner-content">
                  <h1 className="heading mb-3 font-size-48">
                    <span className="title-sub-text">FOR TAXI DISPATCH, RESTAURANTS, GROCERS, PHARMA, AND MORE!</span>
                    Operating system to <span className="text-primary fw-bold">automate your business</span>
                  </h1>
                  <p className="subline fw-medium text-accent">
                    For Taxi dispatch, Restaurants, Food, Groceries, Ride-Hailing, Pharmaceuticals, and more!
                  </p>
                  <p className="subline mb-4-lg">
                    Become a trusted brand and open new revenue streams for your business with our all-in-one taxi dispatch and online ordering & delivery platform.
                  </p>
                  <div className="d-grid0 gap-2 mb-3">
                    <Link to="/pricing" className="btn btn-lg btn-primary-theme me-4 mb-3">
                      <span>Request a free trial</span>
                    </Link>

                    <Link to="/contact" className="btn btn-lg btn-primary-theme-outline mb-3">
                      <span>Contact sales</span>
                    </Link>
                  </div>
                  <ul className="check-circle-list list-unstyled lead mb-0">
                    <li>No additional charges</li>
                    <li>Competitive pricing</li>
                    <li>No strings attached</li>
                  </ul>
                </div>
                <div className="banner-logo mt-5">
                  <p className="fw-bold text-accent">Featured On</p>
                  <StaticImage loading="lazy" src={YelowsoftFeatureOnIcon} width={393} height={24} alt="yelowsoft-feature-on-icon" />
                </div>
              </Col>
              <Col lg={6} className="align-items-self-end text-center ms-xxl-auto d-none d-lg-block">
                <LazyLoad>
                  <Animations animation={YelowsoftBannerImg} />
                </LazyLoad>
              </Col>
            </Row>
          </Container>
        </section> */}
        <MultipleProjectDelivered
          smallTitle="ONLINE ORDERING AND DELIVERY SYSTEM"
          title="We cater to all taxi businesses – from <span class='text-primary'>startups to enterprises!</span>"
          content="Join 500+ taxi businesses worldwide that have transformed operations with Yelowsoft’s top-rated taxi dispatch platform. Trusted by top ride-hailing companies, taxi startups, and corporate transport providers in 40+ countries."
        />

        <section className="section">
          <Container className="py-5">
            <div className="section-title mb-5 pb-2 text-center max-width-950 mx-auto">
              <h2 className="heading mb-0">
                Our<span className="text-primary"> USPs</span>
              </h2>
            </div>

            <Row className="g-3" xs={2} sm={2} md={3} xl={4}>
              {featuredatanewpoint?.map((item, index) => (
                <Col key={index}>
                  <div className="card equal-height border-0 bg-light text-center">
                    <div className="card-body">
                      <div className="icon-size-85 yellow-rounded-circle mb-4 mx-auto">
                        <LazyLoad offset={150}>
                          <Image loading="lazy" className="lazyload" src={item.img} width={item.width} height={item.height} alt="Surgepricing " />
                        </LazyLoad>
                      </div>
                      <h3 className="h4 mb-0 fw-medium">{item.feturetext}</h3>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>


        <section className="section">
          <Container className="py-5">
            <div className="section-title mb-5 pb-2 max-width-950 mx-auto text-center">
              <h2 className="heading h2 mb-4">
                Best <span className="text-primary">taxi software solutions</span> for your business
              </h2>
              <p className="subline lead mb-0">Whether you offer ride-hailing, taxi dispatch, corporate, airport or limo transfer services, we have the best taxi dispatch software as solution to meet all your basic and modern needs.</p>
            </div>
            <Swiper
              slidesPerView={3}
              spaceBetween={30}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              pagination={{
                clickable: true,
              }}
              modules={[Autoplay, Pagination]}
              className="services-slider"
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3
                },
              }}
            >
              {swiperdata?.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="card equal-height">
                    <div className="card-body d-flex flex-column">
                      <div className="position-relative">
                        <div className="default-content">
                          <div className="d-flex align-items-center mb-4-lg">
                            <LazyLoad offset={150}>
                              <div className="me-3">
                                <Image loading="lazy" className="lazyload" src={item.img} width={35} height={35} alt="icon" />
                              </div>
                            </LazyLoad>
                            <h3 className="fw-medium font-size-26 mb-0" dangerouslySetInnerHTML={{ __html: item.title }} />
                          </div>
                          <p>{item.description}</p>
                          <ul className="check-list list-unstyled mb-4-lg">
                            {item?.list?.map((item, index) => (
                              <li key={index}>{item.list1}</li>
                            ))}
                          </ul>
                        </div>
                        <div className="hover-content">
                          <LazyLoad offset={150}>
                            <div className="icon-size-60 d-flex justify-content-center align-items-center mb-4-lg yellow-rounded-circle">
                              <Image loading="lazy" className="lazyload" src={item.hoverimg} width={30} height={30} alt="icon-hover" />
                            </div>
                          </LazyLoad>
                          <h4 className="mb-4">{item.hovertitle}</h4>
                          <ul className="check-circle-list list-unstyled mb-4-lg">
                            {item?.hoverlist?.map((item, index) => (
                              <li key={index}>
                                {
                                  item.hoverlistlink1 ?
                                    <Link className="text-body force-hover" to={item.hoverlistlink1}>{item.hoverlist1}</Link> :
                                    item.hoverlist1
                                }
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                      <div className="d-grid mt-auto">
                        {
                          item.explorelink ?
                            < Link to={item.explorelink} className="btn btn-lg btn-link">
                              <span>{item.explore}</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                            </Link> :
                            <div className="d-grid mt-auto">
                              <p className="text-center fw-semibold text-grey lead pb-0">Coming soon</p>
                            </div>
                        }
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
              {/* <SwiperSlide>
                <div className="card equal-height">
                  <div className="card-header d-flex align-items-center pb-0">
                    <i className="home-products-sprit-icon icon-4 icon-size-30 me-2"></i>
                    <h3 className="font-size-26 mb-0">Yelow<span className="text-primary">Send</span></h3>
                  </div>
                  <div className="card-body d-flex flex-column">
                    Boost your parcel delivery business and give your customers an exceptional experience.
                    <hr className="my-4" />
                    <h4 className="h5 mb-3">Our solutions</h4>
                    <ul className="check-list list-unstyled mb-4-lg">
                      <li><Link className="text-body force-hover" to="/on-demand-courier-parcel-delivery-software-solution">Parcel Delivery</Link></li>
                    </ul>
                    <div className="d-grid mt-auto">
                      <Link to="/on-demand-courier-parcel-delivery-software-solution" className="btn btn-lg btn-primary-theme">
                        <span>Parcel delivery</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide> */}
            </Swiper>
          </Container>
        </section>
        <section className="section bg-cta-gradiant section-background py-lg-0">
          <Container>
            <Row className="g-5 align-items-center" xs={1} md={2}>
              <Col>
                <div className="section-title mb-4 pb-2">
                  {/* <p className="subline lead text-white opacity-75">
                    Want to know how Yelowsoft can help you grow?
                  </p> */}
                  <h2 className="h1 heading mb-0 text-white fw-medium">Explore Our Top-Rated Taxi Dispatch Software – 100% Free! </h2>
                </div>
                <a href="/demo" className="btn btn-lg btn-primary-theme" aria-label="Book a demo" rel="noreferrer" target="_blank">
                  <span>Book a demo</span>
                </a>
              </Col>
              <Col className="text-center d-none d-md-block">
                <StaticImage loading="lazy" src={CtaImage1} width={510} height={420} alt="Taxi dispatch software" />
              </Col>
            </Row>
          </Container>
          <div className="section-background-image">
            <LazyLoad>
              <StaticImage loading="lazy" src={BgGradiantLine} width={1920} height={700} alt="BgGradiantLine" />
            </LazyLoad>
          </div>
        </section>
        <Featureyelowtaxi
          smallTitle="ON-DEMAND DELIVERY SOFTWARE"
          title="Everything You Need to <span class='text-primary'>Run & Grow Your Taxi Business Effortlessly</span>"
          description="Buy the entire white-label taxi management software or choose only the modules you need—pay only for what you use!​"
          featuredata={featuredata}
          sectionClass="bg-white"
        />
        <section className="section bg-thirdparty-gradiant">
          <Container className="py-5">
            <Row className="g-5 align-items-center" xs={1} lg={2}>
              <Col className="order-lg-2">
                <div className="section-title pb-2">
                  {/* <h2 className="title-sub-text text-white">WHITE LABEL ORDERING AND DELIVERY PLATFORM</h2> */}
                  <h2 className="heading h2 mb-4 text-white">
                    Third party integrations to enhance your <span className="text-primary">business performance</span>
                  </h2>
                  <p className="subline lead mb-lg-4 text-grey">We integrate any third-party tool you need into your existing software or with Yelowsoft's white-label taxi dispatch software. Just name the tool and our experts will integrate it.</p>
                  <ul className="check-list  list-unstyled mt-4 text-white">
                    <li>Integrate local payment and SMS gateways</li>
                    <li>Integrate social media channels and more</li>
                    <li>Automation to replace tedious manual work</li>
                    <li>Custom integration to suit your needs</li>
                  </ul>
                </div>
                <Link to="/integrations" className="btn btn-lg btn-link text-white force-hover px-0">
                  <span>Explore Integrations </span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                </Link>
              </Col>
              <Col>
                <Row xs={1} className="g-4 g-lg-5">
                  {
                    slidergo.map((item, index) => (
                      <Col key={index}>
                        <div className="integration-box py-4">
                          <p className="text-white fw-medium text-uppercase opacity-75 mb-4 px-4">{item.title}</p>
                          <LazyLoad height={60}>
                            <Swiper className="integration-logo-slider swiper-nonstop text-center"
                              modules={[Autoplay]}
                              spaceBetween={30}
                              slidesPerView={"auto"}
                              autoplay={{
                                delay: 0,
                                disableOnInteraction: false
                              }}
                              dir={item.keyname === "notification" ? "rtl" : ""}
                              speed={10000}
                              loop={true}
                              // loopFillGroupWithBlank={true}
                              allowTouchMove={false}
                            >
                              {
                                item.newlogo.map((item, index) => (
                                  <SwiperSlide key={index}>
                                    <i className={`third-party-sprite ${item.class} icon`}></i>
                                  </SwiperSlide>
                                ))
                              }
                            </Swiper>
                          </LazyLoad>
                        </div>
                      </Col>
                    ))}
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section overflow-hidden">
          <Container className="py-5">
            <div className="section-title mb-5 pb-2 max-width-950 mx-auto text-center">
              <h2 className="heading h2">
                Why Yelowsoft is the <span className="text-primary">Best Taxi Software</span> for Your Business?
              </h2>
            </div>
            <Tab.Container id="left-tabs-example" defaultActiveKey="0">
              <Row lg={2} xs={1} className="g-5 why-yelowsoft-tabs">
                <Col>
                  <Nav variant="pills" className="flex-column mb-0">
                    {RevolutionizingTab?.map((item, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link eventKey={index}>
                          <div className="d-flex align-items-center">
                            <div className="me-3">
                              <Image loading="lazy" className="lazyload" src={item.icon} width={42} height={42} alt={item.title} />
                            </div>
                            <h3 className="heading mb-0 font-size-24">{item.title}</h3>
                          </div>
                          <div className="hide-by-default">
                            <p className="pt-3 m-0">{item.description}</p>
                          </div>
                        </Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Col>
                <Col className="bg-half-background text-center d-none d-lg-block">
                  <Tab.Content className="pt-lg-5">
                    {RevolutionizingTab.map((item, index) => (
                      <Tab.Pane className="text-lg-end" key={index} eventKey={index}>
                        {
                          item.keyname === "easytouse" ?
                            <StaticImage loading="lazy" src={HomeTabImage1} width={574} height={704} alt={item.title} /> :
                            null
                        }
                        {
                          item.keyname === "security" ?
                            <StaticImage loading="lazy" src={HomeTabImage2} width={574} height={704} alt={item.title} /> :
                            null
                        }
                        {
                          item.keyname === "support" ?
                            <StaticImage loading="lazy" src={HomeTabImage3} width={574} height={704} alt={item.title} /> :
                            null
                        }
                        {
                          item.keyname === "white-label" ?
                            <StaticImage loading="lazy" src={HomeTabImage4} width={574} height={704} alt={item.title} /> :
                            null
                        }
                        {
                          item.keyname === "data-migration" ?
                            <StaticImage loading="lazy" src={HomeTabImage5} width={574} height={704} alt={item.title} /> :
                            null
                        }
                        {
                          item.keyname === "software-pricing" ?
                            <StaticImage loading="lazy" src={HomeTabImage6} width={574} height={704} alt={item.title} /> :
                            null
                        }
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </Container>
        </section>
        <section className="section bg-cta-gradiant section-background">
          <Container>
            <Row className="g-5 align-items-center" xs={1} md={2}>
              <Col lg={7}>
                <div className="section-title mb-4 pb-2">
                  <h2 className="h1 heading mb-0 text-white fw-medium">Don't trust our words, Try our DEMO Software for FREE</h2>
                  {/* <p className="subline lead text-white opacity-75 mb-0">
                    Get a complete 7-day free trial. No credit card required. Access product instantly.
                  </p> */}
                </div>
                <a href="https://service.yelowsoft.co/signup?pricing=3" className="btn btn-lg btn-primary-theme" aria-label="Get Started Free" rel="noreferrer" target="_blank">
                  <span>Get Started For FREE</span>
                </a>
              </Col>
              <Col lg={5} className="text-center d-none d-md-block">
                <StaticImage loading="lazy" src={CtaImage2} width={487} height={407} alt="Taxi dispatch software" />
              </Col>
            </Row>
          </Container>
          <div className="section-background-image">
            <LazyLoad>
              <StaticImage loading="lazy" src={BgGradiantLine} width={1920} height={700} alt="BgGradiantLine" />
            </LazyLoad>
          </div>
        </section>
        <Client
          smallTitle="ON-DEMAND TAXI DISPATCH SYSTEM"
          title="Why <span class='text-primary'>Taxi Business Owners</span> Love Yelowsoft?"
          description="More Bookings. Less Stress. Faster Growth. See what our customers have to say!"
          sectionClass="bg-light"
        />
        <Facts
          smallTitle="ON-DEMAND ORDERING AND DELIVERY SOFTWARE"
          title="Facilitating growth for <span class='text-primary'>taxi businesses since 8+ years</span>"
          description="The numbers speak for themselves. Yelowsoft is the go-to taxi dispatch software for ambitious fleet owners looking to grow faster and operate smarter."
        />
        {/* <Solutionyelowtaxi
          dispatch={true}
          food={true}
          retail={true}
        /> */}
        <Faqs accordiandata={accordiandata} />
        <section className="section bg-cta-gradiant section-background">
          <Container className="py-5">
            <div className="mx-auto text-center">
              <div className="section-title mb-4 pb-2">
                <h2 className="h1 heading mb-0 text-white fw-medium">Get exclusive access of top industry insights and latest global taxi business trends</h2>
              </div>
              <a href="/demo" className="btn btn-lg btn-primary-theme" aria-label="Book a demo" rel="noreferrer" target="_blank">
                <span>Sign Up For Monthly Newsletter</span>
              </a>
            </div>
          </Container>
          <div className="section-background-image">
            <LazyLoad>
              <StaticImage loading="lazy" src={BgGradiantLine} width={1920} height={700} alt="BgGradiantLine" />
            </LazyLoad>
          </div>
        </section>


        <section className="section">
          <Container className="py-5 max-width-950">
            <div className="section-title mb-5 pb-2 text-center">
              <h2 className="heading h2 mb-0">
                Recognized by global industry pioneers
              </h2>
            </div>
            <Row md={3} sm={2} xs={1} className="g-4 text-nowrap">
              <Col>
                <Card className="equal-height text-center recognized-card">
                  <Card.Body className="d-flex flex-column">
                    <div className="my-auto">
                      <StaticImage loading="lazy" src={SoftwareAdvice} width={175} height={55} alt="SoftwareAdvice" />
                    </div>
                    <div className="d-flex align-items-center mt-4 justify-content-center">
                      <span className="rating-label">Ratings :</span>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star-half"></i>
                    </div>
                  </Card.Body>

                </Card>
              </Col>
              <Col>
                <Card className="equal-height text-center recognized-card">
                  <Card.Body className="d-flex flex-column">
                    <div className="my-auto">
                      <StaticImage loading="lazy" src={Capterra} width={175} height={39} alt="Capterra" />
                    </div>
                    <div className="d-flex align-items-center mt-4 justify-content-center">
                      <span className="rating-label">Ratings :</span>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                    </div>
                  </Card.Body>

                </Card>
              </Col>
              <Col sm={12} md={4}>
                <Card className="equal-height text-center recognized-card">
                  <Card.Body className="d-flex flex-column">
                    <div className="my-auto">
                      <StaticImage loading="lazy" src={ProductHunt} width={220} height={39} alt="ProductHunt" />
                    </div>
                    <div className="d-flex align-items-center mt-4 justify-content-center">
                      <span className="rating-label">Ratings :</span>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star"></i>
                      <i className="text-secondary zmdi zmdi-hc-lg ms-1 zmdi-star-half"></i>
                    </div>
                  </Card.Body>

                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <FooterCta
          title="Your business success <span class='fw-semibold'>= Yelowsoft</span>"
          description="Get a 7 day free trial and begin your growth ride."
        />
      </Layout >
    </>
  );
};

export default IndexPage;
